export enum SupplierInboxSubType {
  JobSearch = 1,
  ExistingJobs = 2,
}
